import { DROPAREA_PADDING, DropAreaWithPadding, StyledDropArea } from "@components/fileUploader";
import { StyledToolbar } from "@components/toolbar/Toolbar.styles";
import styled from "styled-components";

import { T_TITLE_4_NORMAL } from "../../global.style";
import View from "../View";

export const FileViewStyled = styled(View)`
    ${StyledDropArea} {
        ${DropAreaWithPadding};
        margin-top: ${DROPAREA_PADDING}px;
    }
    
    ${StyledToolbar} {
        margin-top: 17px;
    }
}`;

export const FormAttachmentsFolderTitle = styled.div`
    ${T_TITLE_4_NORMAL};
    position: absolute;
    text-transform: uppercase;
    top: 13px;
    left: 37px;
    
    & > span {
        text-transform: none;
    }
`;